// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:601px){.installed-modal__container[data-v-5c427754]{padding:30px 40px}}.installed-modal__body[data-v-5c427754]{margin-top:10px}.installed-modal__text[data-v-5c427754]{line-height:19px}.installed-modal__img[data-v-5c427754]{transform:translateX(-23px)}.installed-modal__footer[data-v-5c427754]{margin-top:30px;display:flex;justify-content:center;align-items:center}.installed-modal__ok-btn[data-v-5c427754]{min-width:115px!important}", ""]);
// Exports
module.exports = exports;
